import { render, staticRenderFns } from "./Act_myform.vue?vue&type=template&id=04a64979&scoped=true"
import script from "./Act_myform.vue?vue&type=script&lang=js"
export * from "./Act_myform.vue?vue&type=script&lang=js"
import style0 from "./Act_myform.vue?vue&type=style&index=0&id=04a64979&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a64979",
  null
  
)

export default component.exports